<template>
 <portal target-el="#boxrahmen">
  <transition name="movein">
  <div id="hintergrund_button" class="hintergrundbutton z50 pointer active" ref="hintergrundbutton" v-if="showbutton">
      <img src="/static/assets/alle/Hintergrund_lasche.png" class="hintergrundbuttonBackground" />
      <img src="/static/assets/alle/Hintergrund_lasche_an.png" class="hintergrundbuttonBackgroundAn" @click="setAn"/>
      <img src="/static/assets/alle/Hintergrund_lasche_aus.png" class="hintergrundbuttonBackgroundAus" @click="setAus" />
  </div>

  </transition>
</portal>
</template>
<script>
/* eslint no-trailing-spaces: "off" */

function promiseState(p) {
  const t = {};
  return Promise.race([p, t])
    .then(v => (v === t)? "pending" : "fulfilled", () => "rejected");
}

window.$ = window.jQuery = require('jquery')
export default {
  name: 'Hintergrundbutton',
  data () {
    return {
      who: 'Hintergrundbutton',
      retval: 0,
      showbutton: false
    }
  },
/*  watch: {
    showbutton: function (oldval, newval) {
      console.log('watch showbutton: ', oldval, newval)
    }
  },*/
  methods: {
    setAn () {
      this.showbutton = false
      window.hintergrundSound.muted = false      
      window.hintergrundSound.play()
      console.log('setAn', this.showbutton)
    },
    setAus () {
      this.showbutton = false
      window.hintergrundSound.muted = true      
      window.hintergrundSound.pause()      
      console.log('setAus', this.showbutton)
    },
  },
  mounted () {
    //var left = $('#app').offset().left;
    //$('#boxrahmen').css('left', left + 200 + 'px')
    //console.log('links dingsta bumsta', $('#app').offset())

    var testAudio = null
    testAudio = new Audio('/static/assets/alle/1-second-of-silence.mp3')
    testAudio.muted = false
    console.log('testing audio play capabilities')
    var promise = testAudio.play()
    this.showbutton = false
    if (promise !== undefined) {
        promise.catch(error => {
            // Auto-play was prevented
            // Show a UI element to let the user manually start playback
            console.log("player nicht erlaubt")
            this.showbutton = true
        }).then(() => {
            console.log("showbutton false")
        });
    }
  }
}
</script>
<style scoped>

.hintergrundbutton {
  position: absolute;
  left: -200px;
  top: 200px;
  z-index: 99999 !important;
  overflow:hidden;

}

@keyframes hgbfadein {
    0% {opacity:0; left: -400px;}
    100% {opacity:1; left: -200px;}
}

.hideshowbutton {
  opacity:0;
  /* 
  animation: hgbfadeout 1s ease-out; 
  animation-delay: 0s; 
  animation-fill-mode: forwards; 
  */
}

@keyframes hgbfadeout {
    0% {opacity:1; left: -200px;}
    100% {opacity:0; left: -400px;} 
} 

.hintergrundbuttonBackgroundAus {
    position: absolute;
    top: 137px;
    left: 197px;
}

.hintergrundbuttonBackgroundAn {
    position: absolute;
    top: 137px;
    left: 297px;
}

.movein-enter-active {
  opacity: 0;
  animation: hgbfadein 1s ease-out; 
  animation-delay: 2s; 
  animation-fill-mode: forwards; 
}

.movein-leave-active {
  animation: hgbfadeout 1s ease-out; 
  animation-delay: 0s; 
  animation-fill-mode: forwards; 
}


.movein-enter, .movein-leave-to {
  opacity: 0;
  left: -400px;
}

@media screen and (max-height: 414px) {
  .hintergrundbutton{
    transform: scale(0.6);
  transform-origin: 250px -210px;
}
}

</style>


// WEBPACK FOOTER //
// src/components/Hintergrundbutton.vue